import { render, staticRenderFns } from "./DealsTable.vue?vue&type=template&id=4e2340fa&scoped=true&"
import script from "./DealsTable.vue?vue&type=script&lang=js&"
export * from "./DealsTable.vue?vue&type=script&lang=js&"
import style0 from "./DealsTable.vue?vue&type=style&index=0&id=4e2340fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2340fa",
  null
  
)

component.options.__file = "DealsTable.vue"
export default component.exports